module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./HeatExchanger.js"));
	}, "HeatExchanger");
}